import Vue from 'vue';
import VueI18n from 'vue-i18n';
import GERMAN_TRANSLATIONS from '../translations/ge';
import GERMAN_RECORD_TRANSLATIONS from '../translations/ge_record';
import GERMAN_MANUALBESTLIST_TRANSLATIONS from '../translations/ge_manualbestlist';
import GERMAN_IOC from '../translations/ge_IOC';
import ENGLISH_TRANSLATIONS from '../translations/en';
import ENGLISH_RECORD_TRANSLATIONS from '../translations/en_record';
import ENGLISH_MANUALBESTLIST_TRANSLATIONS from '../translations/en_manualbestlist';
import ENGLISH_IOC from '../translations/en_IOC';
import DUTCH_TRANSLATIONS from '../translations/nl';

Vue.use(VueI18n);

const TRANSLATIONS = {
	ge: { text: { ...GERMAN_TRANSLATIONS.text, ...GERMAN_RECORD_TRANSLATIONS.text, ...GERMAN_MANUALBESTLIST_TRANSLATIONS.text }, ...GERMAN_IOC },
	en: { text: { ...ENGLISH_TRANSLATIONS.text, ...ENGLISH_RECORD_TRANSLATIONS.text, ...ENGLISH_MANUALBESTLIST_TRANSLATIONS.text }, ...ENGLISH_IOC },
	nl: { text: { ...DUTCH_TRANSLATIONS.text }, ...ENGLISH_IOC },
};

function getBrowserLocale(options = {}) {
	const defaultOptions = { countryCodeOnly: false };
	const opt = { ...defaultOptions, ...options };
	const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

	if (!navigatorLocale) {
		return undefined;
	}

	const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();
	return trimmedLocale;
}

function getStartingLocale() {
	const browserLocale = getBrowserLocale({ countryCodeOnly: true });
	if (browserLocale == 'de') {
		return 'ge';
	}
	if (browserLocale == 'en') {
		return 'en';
	}
	if (browserLocale == 'nl') {
		return 'nl';
	}
	return 'ge';
}

export default new VueI18n({
	locale: getStartingLocale(),
	fallbackLocale: 'ge',
	messages: TRANSLATIONS,
});

Vue.moment().locale('de-at');
